var render = function render(){var _vm=this,_c=_vm._self._c;return _c('BaseTable',{attrs:{"name":_vm.name,"getDataAction":_vm.getDataAction,"tableColumns":_vm.tableColumns,"isShowCloseBtn":_vm.isShowCloseBtn},on:{"SizeChange":_vm.sizeChange,"StateChange":_vm.stateChange}})
}
var staticRenderFns = []

export { render, staticRenderFns }